import RouteTranslator from '../util/route-translator';

export default {
	methods: {
		/**
		 * @param {string} route The route to translate.
		 * @returns {string} The translated route.
		 */
		translateRoute (route) {
			return this.getRouteTranslator()
				.then((routeTranslator) => {
					return routeTranslator.translateRoute(route);
				});
		},

		/**
		 * Get the route translator for the current domain
		 *
		 * @returns {Promise<RouteTranslator>} The route translator
		 */
		getRouteTranslator () {
			return RouteTranslator.createForCurrentDomain();
		},
	}
};
